import ApiService from '@/services/core/api.service'

const DispositionTypeService = {
  async get (query) {
    return ApiService.get(`supervisor/disposition-types?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/disposition-types', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/disposition-types/${payload.id}`, payload)
  }
}

export default DispositionTypeService
